
import React, { useCallback } from "react";
import "./styles.css";
import Datalayer from "../../../../libs/vendors/data-layer";
import { CLICK_ACTIONS, CLICK_DESCRIPTION } from "../../../../constants/datalayer";
import Button from "../../../../components/Button/Button";

function DiscountLegalSection() {
    const handleOnScrollTo = useCallback(() => {
        const element = document.getElementsByTagName("header")[0];
        const top = element.offsetTop;
        window.scrollTo({
            behavior: "smooth",
            top,
        });
        Datalayer.sendClickAction(
            "Inicio",
            `${CLICK_ACTIONS.SELECT_BUTTON}: ${CLICK_DESCRIPTION.BTN_GO_BACK}`
        );
    }, []);

    return (
        <div className="discount-legal-section text-center">
            <Button
                type="button"
                className="discount-legal-section__go-top rounded"
                onClick={handleOnScrollTo}
            >
                Volver al inicio
            </Button>
            <div>
                <p className="discount-legal-section__discount">
                    *Aplican Términos, Condiciones y Exclusiones que
                    <br /> puedes revisar en https://www.pacifico.com.pe/
                    <br />
                    seguros/hogar/documentos
                </p>
                <p className="discount-legal-section__personal-data-consent">
                    El detalle de nuestra clausula de protección de datos
                    <br /> personales se encuentra disponible
                    <br /> en https://www.pacifico.com.pe/
                    <br />
                    transparencia/politica-privacidad
                </p>
                <p className="discount-legal-section__sbs-code">
                    El Seguro de Hogar Flex Digital es un producto ofrecido por Pacífico
                    Compañía de Seguros y Reaseguros. Código de registro SBS N°
                    RG2005200233
                </p>
            </div>
        </div>
    );
}

export default DiscountLegalSection;
